import { localeFor } from './dateLocale';

const localeOf = (language: string | undefined) => localeFor(language?.slice(0, 2));

/** A source rating with its one decimal: « 4,5 » in French, "4.5" in English. */
export function formatRating(rating: number, language: string | undefined): string {
  return new Intl.NumberFormat(localeOf(language), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(rating);
}

/** A count with the language's own thousands separator, whatever the device says. */
export function formatCount(count: number, language: string | undefined): string {
  return new Intl.NumberFormat(localeOf(language)).format(count);
}

/**
 * A price in Canadian dollars unless a receipt named another currency: « 3,99 $ »
 * and "$3.99". A receipt's `currency` is sometimes the bare sign, hence the test.
 */
export function formatMoney(amount: number, language: string | undefined, currency?: string): string {
  return new Intl.NumberFormat(language?.startsWith('fr') ? 'fr-CA' : 'en-CA', {
    style: 'currency',
    currency: currency && /^[A-Za-z]{3}$/.test(currency) ? currency.toUpperCase() : 'CAD',
  }).format(amount);
}
